import { useEffect, useRef } from "react";
import { Navigate, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { showUpgradeRequiredPopup } from "../utils/subscriptionAccess";

export default function ModuleAccessGuard({
  allowed,
  fallbackPath = "/dashboard",
  children,
}) {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const shownRef = useRef(false);

  useEffect(() => {
    if (allowed || shownRef.current) return;
    shownRef.current = true;
    showUpgradeRequiredPopup({
      t,
      onUpgrade: () => navigate("/upgrade"),
    });
  }, [allowed, navigate, t]);

  if (!allowed) {
    return <Navigate to={fallbackPath} replace />;
  }

  return children;
}
